export default "__VITE_ASSET__53e15be4__"